    <script>
		import { infoPopup } from "../shared/stores.js";
        export let innerHeight;
        export let innerWidth;
        export let mainBgColor;
        export let mainDrawColor;
        export let mainBgColorControls;
        export let mainBorderColor;
        export let mainSpecialColor;
		export let mainTitleColor;
        export let darkMode;
		export let borderWidthBoxes;
		export let borderWidthButtons;
		export let boxShadow;
        // export let infoPopup;
		export let headerItemsMargins;
		export let distPlotWidthRatio;
        // $: infoPopup = false;
        $: selectedPage = "about"

		$: infoData = 
			{
			methods:  
					[{label:"Data sources", text:`Two main sources of data are behind this research. <a href="https://www.openstreetmap.org/#map=19/40.71651/-73.99983" target=_blank style="color:${mainSpecialColor}">OpenStreetMap</a> is used to collect data on pedestrian infrastructure and geographically allocated places of interest (POI): hospitals, schools, supermarkets, restaurants, schools, etc. POIs are returned by the OpenStreetMap API as amenity names and their associated geographical location (i.e. longitude and latitude). Pedestrian infrastructure networks are returned by the OpenStreetMap API as networks of nodes and edges, where each node represents a street intersection and each edge represents a segment of road with walkable or bikable features. Next, we group POI types into a set of different categories (see SI for a complete list of amenities and their associated category). Data on population density for every city is retrieved from the European Commission's 2020 <a href="https://ghsl.jrc.ec.europa.eu/download.php?ds=pop" target=_blank style="color:${mainSpecialColor}">Global Human Settlement Layer (GHSL)</a>. This data is retrieved in the form of a grid of 100m by 100m squares and their associated population density values covering the entire world.`},
					{label:"Accessibility analysis", text:`To measure accessibility to services for each city, we perform a network analysis on the pedestrian street networks and (POIs) data to quantify and map accessibility to urban infrastructure at the block level. For each 100m cell, the resulting "walking time" reflects the time that a person residing inside that cell would have to walk for, using the existing pedestrian infrastructure (i.e. sidewalks, walking paths etc.), to reach the first amenity from a given category of services. This value is averaged across all services.`},
					{label:"Calculation of 15 minute accessibility by population", text:`Using the population grid associated with each city, we select all squares where average accessibility is equal to a 15 minute walk or less and sum their respective population values. This gives us fraction of the population of each city that lives within a 15 minute walk of services. Using the application interface, this fraction can be re-calculated by assigning different weights to each service.`},
					{label:"Limitations", text:`The main limitation of this tool are associated with the fact that the POI and street-network data (from OpenStreetMap) it uses is user-generated. As a result the accessibility results that we present may be more or less accurate depending on the city. In general, however, research has shown that OpenStreetMap data is more representative of real-world land use patterns. The OpenStreetMap street network, for example, was <a href="https://journals.plos.org/plosone/article?id=10.1371/journal.pone.0180698" target=__blank style="color:${mainSpecialColor}">83% accurate</a> as of 2019.`}],
			FAQ:
					[{label:"Is your data representative?", text:"In general, yes, our data can be used to gather insights into how accessibility  is distributed across space and populations. Because we use user-generated data as one of our data-sources, however, it is possible that accuracy is lower in some cities and higher in others. Users should be aware of this limitation and, if possible, conduct some ground-validation when using this tool for the development of new public policies or for the allocation of new investments in infrastructure."},
					 {label: "Why isn't my city/town on here?", text:"This application considers any urban area that is home to at least 100,000 inhabitants. If there is no data for your city it is probably because its population is lower than this threshold."},
					 {label:"Why does my city look bigger than its municipal boundaries?", text:`This application does not consider municipal boundaries for defining city borders. Rather, it considers "Functional Urban Areas" <a href="https://publications.jrc.ec.europa.eu/repository/handle/JRC118845" target=__blank style="color:${mainSpecialColor}">as defined by the OECD and the European Union</a>. The boundaries of Functional Urban Areas consider urbanization factors such as commuting flows and population density, and are less arbitrary than municipal boundaries. For this reason, cities presented here may have a different (and often bigger) shape than what may be expected.`},
					 {label:"Why are there empty spots with no data in some cities?", text:"For some extremely large metropolitan areas (e.g. New York City, Tokyo), grid cells where the population is zero have been removed in order to reduce the amount of data that is loaded and to improve the speed of the application. In most cases, these areas represent large parks, natural areas, or industrial sites."},
					 {label:"How often is this data updated?", text:"The data used in this application is up-to-date as of July, 2022. It will be be updated at least twice a year to reflect the evolution of land-use processes across the world."},
					 {label:"How was this application developed?", text:`The data-analysis part of this application was conducted using the Python programming language. The application itself was developed using the <a href="https://svelte.dev/" target=__blank style="color:${mainSpecialColor}">Svelte</a> Javascript framework and the <a href="https://d3js.org/" target=__blank style="color:${mainSpecialColor}">D3.js</a> and <a href="https://docs.mapbox.com/mapbox-gl-js/api/" target=__blank style="color:${mainSpecialColor}">Mapbox GL JS</a> libraries.`},
					 {label:"Where can I download this data?", text:`You can download any city's data-set <a href="https://github.com/lnicoletti/city-access-map/tree/master/data" target=__blank style="color:${mainSpecialColor}">here</a>. Please note that each file is named according to the European Commission's naming convention found in <a href="https://ghsl.jrc.ec.europa.eu/ghs_fua.php" target=__blank style="color:${mainSpecialColor}">this dataset</a>.`},
					 {label:"How can I replicate this analysis?", text:`You can replicate this analysis using <a href="https://github.com/lnicoletti/city-access-map/tree/master/dataPreparation" target=__blank style="color:${mainSpecialColor}">these Python scripts</a>.`}],
			// stories:[{label:"Story 1", text:""}]
		}
				
		// console.log(infoData)

    </script>
    
	<div class="appTitle" 
     style="top:10px;right:{innerWidth>500?headerItemsMargins:innerWidth*0.5-251.46/2}px;
            color: {mainDrawColor};" >
    <span style="color:{mainTitleColor};cursor:default"><span style="text-transform: uppercase;">City<span style="color:{mainSpecialColor};">Access</span>Map</div>
	<div id="infoPoint" 
     style="background-color:{$infoPopup===false?mainSpecialColor:"transparent"};
	 		border: 1px solid {$infoPopup===false?"transparent":mainSpecialColor};
            color: {mainDrawColor};" on:click={()=> infoPopup.set(!$infoPopup)}>
    <span 
	class="material-symbols-outlined" 
	style="color:{$infoPopup===false?mainBgColor:mainSpecialColor};
		   margin:auto;
		   font-variation-settings:
		   {$infoPopup===true?"'FILL' 1":"'FILL' 1"};
		   transform:translate(-43px,43px)"
	>lightbulb
	</span>
	</div>
    {#if $infoPopup===true}
    <!-- <div id="infoPopup" 
         style="transform:translate({innerWidth*0.04}px, {innerHeight*0.12}px);
                background-color: {mainBgColorControls};
                color: {mainDrawColor};"> -->
        <div id="infoPopup" 
            style="height:{innerHeight*0.87}px;
					right:{headerItemsMargins}px;
                    top:50px;
					left:{headerItemsMargins}px;
					max-width:{innerWidth*distPlotWidthRatio}px;
                    background-color: {mainBgColorControls};
                    color: {mainDrawColor};
					border: {borderWidthBoxes}px solid {mainBorderColor};
					box-shadow: {darkMode===true?"none":boxShadow};
					border-radius:3px;
					text-align: {innerWidth<640?"left":"justify"}">
            <div style="text-align:right;">
                <button class="closeButton" 
                            style="background-color: {mainBgColorControls};
                            color: {mainDrawColor};
							top: 3px;
                            right:5px;
							font-size:{innerWidth>500?14:10}px;
                            border: 0px solid {mainBorderColor}" on:click={()=>{
                                infoPopup.set(false)
                                }}>X
                </button>
            </div>
            <!-- <h2 style="color:{darkMode===true?"white":mainTitleColor}" style="color:white">About</h2> -->
            <div id="buttons" style='display:flex; font-size: {innerWidth<400? 14:16}px'>
                <button 
                class="infoButton"
                style="background-color: {mainBgColorControls};
                    color: {selectedPage==="about"?mainSpecialColor:mainDrawColor};
					font-weight:{selectedPage==="about"?700:500}px;
                    border: {borderWidthButtons}px solid {selectedPage==="about"?mainSpecialColor:mainBorderColor};
					box-shadow: {darkMode===true?"none":boxShadow};"
                on:click={() => {
                    selectedPage = "about"
                }}
                >About
                </button>
                <div class="spacer"></div>
                <button 
                class="infoButton"
                style="background-color: {mainBgColorControls};
                    color: {selectedPage==="methods"?mainSpecialColor:mainDrawColor};
					font-weight:{selectedPage==="methods"?700:500}px;
                    border: {borderWidthButtons}px solid {selectedPage==="methods"?mainSpecialColor:mainBorderColor};
					box-shadow: {darkMode===true?"none":boxShadow};"
                on:click={() => {
                    selectedPage = "methods"
                }}
                >Methods
                </button>
                <!-- <div class="spacer"></div>
                <button 
                class="infoButton"
                style="background-color: {mainBgColorControls};
                    color: {selectedPage==="stories"?mainSpecialColor:mainDrawColor};
					font-weight:{selectedPage==="stories"?700:500}px;
                    border: {borderWidthButtons}px solid {selectedPage==="stories"?mainSpecialColor:mainBorderColor}"
                on:click={() => {
                    selectedPage = "stories"
                }}
                >Stories
                </button> -->
                <div class="spacer"></div>
                <button 
                class="infoButton"
                style="background-color: {mainBgColorControls};
                    color: {selectedPage==="FAQ"?mainSpecialColor:mainDrawColor};
					font-weight:{selectedPage==="FAQ"?700:500}px;
                    border: {borderWidthButtons}px solid {selectedPage==="FAQ"?mainSpecialColor:mainBorderColor};
					box-shadow: {darkMode===true?"none":boxShadow};"
                on:click={() => {
                    selectedPage = "FAQ"
                }}
                >FAQ
                </button>
            </div>
            {#if selectedPage==="about"}
                <h2 style="color:{darkMode===true?"white":mainTitleColor}">Background</h2>
                <p>
                    Today, the quality of life of urban environments is often measured in terms of <i>accessibility</i>: that is, the ability of urban residents to access services and opportunities. Unfortunately, in cities across the world, the dynamics of <a href="https://www.urbandisplacement.org/about/what-are-gentrification-and-displacement/" target=_blank style="color:{mainSpecialColor}">gentrification</a>, the housing market, and other processes like <a href="https://www.whitehouse.gov/cea/written-materials/2021/06/17/exclusionary-zoning-its-effect-on-racial-discrimination-in-the-housing-market/" target=_blank style="color:{mainSpecialColor}">exclusionary zoning laws</a> have pushed underpriviledged communities to live in deteriorated urban areas receiving a minor share of public investments and thus low levels of accessibility. For this reason, today's planners have recognized that many of the social inequalities present in cities are often closely related to accessibility.
                    </p> 
                    <p>As a result, globally, cities have implemented policies aimed at reducing inequalities in accessibility among urban communities, with the objective of achieving the <a href="https://www.c40knowledgehub.org/s/article/Why-every-city-can-benefit-from-a-15-minute-city-vision?language=en_US&gclid=CjwKCAjwpKyYBhB7EiwAU2Hn2VcsLr8Bu8g5cC9ugRwlz0Q3PuhnOCe8p0t9IqQIvSosJfGoCZ1SmRoCl_4QAvD_BwE" target=_blank style="color:{mainSpecialColor}"><i>15 Minute City</i></a>: a city where every urban resident has access to basic services within a 15 minute walk. In the United States alone, <a href="https://www.semanticscholar.org/paper/Evaluation-of-Complete-Streets-Policy-by-Planning-Tolford-Fields/d941e5d4da35f0a0a4d2894ad46053f70b6b59ff" target=_blank style="color:{mainSpecialColor}">more than 500 municipalities</a> have implemented policies for the creation of socially inclusive communities with improved access to services, shops and recreation, healthy and active lifestyles, more walking and less driving, attractive public spaces, and improved economic vitality. But, for such planning interventions to be effective, planners must first assess existing levels of accessibility in their city and identify areas of strategic importance.
                    </p> 
                    <p><i>CityAccessMap</i> was developed by urban scientists, for urban planners, with the objective to drastically simplify this task. It uses open data from <a href="https://www.openstreetmap.org/#map=19/40.71651/-73.99983" target=_blank style="color:{mainSpecialColor}">OpenStreetMap</a> and the <a href="https://ghsl.jrc.ec.europa.eu/download.php?ds=pop" target=_blank style="color:{mainSpecialColor}">Global Human Settlement Layer (GHSL)</a> by the European Commission, to quantify and visualize walking accessibility to a variety of services for any city in the world. Planners can use this tool to obtain both high-level and granular insights into how access to different services is distributed across their city and its population, and how close they are to achieving the <i>15 Minute City</i>.
                    </p>

                <h2 style="color:{darkMode===true?"white":mainTitleColor}">Paper</h2>
                <p>Nicoletti, L., Verma, T., Sirenko, M. (2022). <a style="color:{mainSpecialColor}" href="https://journals.sagepub.com/doi/10.1177/23998083221131044" target=_blank>Disadvantaged Communities Have Lower Access to Urban Infrastructure.</a> Environment and Planning B: Urban Analytics and City Science, 0(0).
                </p>
                <h2 style="color:{darkMode===true?"white":mainTitleColor}">Code</h2>
                <a href="https://github.com/lnicoletti/city-access-map" target=_blank style="color:{mainSpecialColor}">https://github.com/lnicoletti/city-access-map</a>
                <!-- <h2 style="color:{darkMode===true?"white":mainTitleColor}" style="color:white">In collaboration with</h2> -->
                <br>
                <br>
                Built by <a href="https://www.leonardonicoletti.com" target=__blank style="text-transform:capitalize;color:{mainSpecialColor}">Leonardo Nicoletti</a>
                , in collaboration with <a href="https://twitter.com/mikhailsirenko" target=__blank style="text-transform:capitalize;color:{mainSpecialColor}">Mikhail Sirenko</a> and <a href="https://twitter.com/TrivikV" target=__blank style="text-transform:capitalize;color:{mainSpecialColor}">Trivik Verma</a> from
                <div id="logSection" style="margin-bottom:8px;margin-top:8px">
                    <a href="https://www.tudelft.nl/tbm" target=_blank style="color:{mainSpecialColor}">
                        <svg width="100" height="50">       
                            <image xlink:href={darkMode===true?"images/tuDelft_dark.svg":"images/tuDelft_light.svg"} 
                                src={darkMode===true?"images/tuDelft_dark.svg":"images/tuDelft_light.svg"} width="100" height="50"/>    
                        </svg>
                    </a>
                    <a href="https://cusp.tbm.tudelft.nl/" target=_blank style="color:{mainSpecialColor}">
                        <svg width="200" height="50">       
                            <image xlink:href={darkMode===true?"images/CUSP_logo_dark.svg":"images/CUSP_logo_light.svg"} 
                                src={darkMode===true?"images/CUSP_logo_dark.svg":"images/CUSP_logo_light.svg"} width="200" height="50"/>    
                        </svg>
                    </a>
                </div>
            {:else}
				{#each infoData[selectedPage] as d, i}
					<h2 style="color:{darkMode===true?"white":mainTitleColor}">{d.label}</h2>
					<p>{@html d.text}</p>
				{/each}
            {/if}
        </div>
    {/if}

    <style>

	.material-symbols-outlined {
		font-variation-settings:
		'FILL' 0,
		'wght' 300,
		'GRAD' -25,
		'opsz' 48;
	}
	#infoPoint {
		top: 0px;
		right: 0px;
		cursor:pointer;
		/* text-align: center; */

		/* padding-left:8px;
		padding-right:40px;
		padding-top:38px;
		padding-bottom:5px; */
		/* padding:10px; */
		border-radius:50%;
		width:80px;
		height:80px;
		transform: translate(40px,-40px);
		position: absolute
	}

	.appTitle {
        /* font-weight: 900; */
        font-size: 30px;
		position: absolute;
		text-align:center;
		font-family: 'Josefin Sans', sans-serif;
		/* font-family: halyard-micro, sans-serif !important; */
		font-weight: 700;
		/* text-transform: uppercase; */
		/* text-align: right; */
		/* text-align: right; */
	}	
    h2 {
        /* color:white */
    }
    
    main {
		/* text-align: center; */
		/* padding: 1em;
		max-width: 240px; */
		margin: 0 auto;
	}

	#infoPoint:hover {
        font-weight: 900;
        cursor: pointer
	}

	#infoPopup {
		position: absolute;
		z-index:100;
		opacity: 0.9;
		padding-left: 4%;
		padding-right: 4%;
		overflow: auto;
		/* overflow-x: hidden; */
		/* transform: translate(10vw, 10vh); */
		/* background-color: rgb(20, 20, 20); */
	}

	/* #infoPopup::-webkit-scrollbar {
		width:5px; 
	}

	#infoPopup::-webkit-scrollbar-track { 
		width:5px;
	} */

	.sliderFlex {
		margin-bottom: 0;
		margin-top:auto
	}
	.infolink:before {
		content: '?';
		display: inline-block;
		font-family: sans-serif;
		font-weight: bold;
		text-align: center;
		width: 1.8ex;
		height: 1.8ex;
		/* font-size: 1.4ex; */
		line-height: 1.8ex;
		border-radius: 1.2ex;
		margin-right: 4px;
		padding: 1px;
		color: grey;
		background: none;
		border: 1px solid grey;
		text-decoration: none;
	}

	.infolink:hover:before {
		color: white;
		background: grey;
		border-color: white;
		text-decoration: none;
	}

	.appTitle {
		font-family: 'Josefin Sans', sans-serif;
		/* font-family: halyard-micro, sans-serif !important; */
		font-weight: 700;
		/* text-transform: uppercase; */
	}

	#infoPoint {
        font-weight: 900;
        font-size: 30px;
		position: absolute;
		text-align: right;
		/* text-align: right; */
		/* text-align: right; */
	}	
	
	#cuspLogo {
		position: absolute;
		text-align: right;
	}

	.weightSlider {
		display: flex;
		flex-direction: column;
		/* font-size: 13px; */
		/* line-height: 0.02em; */
		text-align: left;
		margin-left: 10px;
		max-width: 150px;
		vertical-align: text-bottom;
		margin-bottom: 0;
		margin-top:auto;
	}

	.resetButton {
		max-width: 150px;
		margin-bottom: auto;
		margin-top:40%;
		margin-left: 10px;
		text-transform: uppercase;
		cursor: pointer;
	}

    .infoButton {
		max-width: 150px;
		margin-bottom: auto;
		margin-left: 0px;
        margin-top:20px;
		text-transform: uppercase;
		cursor: pointer;
		/* font-size: 10px; */
	}

    .spacer {
        width:10px;
    }

    /* .infoButton:hover {
        border-width: 4px;
    } */

	#smartphoneFilterButton {
		max-width: 50px;
		height: 100px;
		cursor: pointer;
		text-transform: uppercase;
	}

	#smartphoneFilterButton span {
		display: inline-block;
    	transform: rotate(90deg) translate(0px, 15px);
		 /* Safari */
		-webkit-transform: rotate(90deg) translate(0px, 15px);

		/* Firefox */
		-moz-transform: rotate(90deg) translate(0px, 15px);

		/* IE */
		-ms-transform: rotate(90deg) translate(0px, 15px);

		/* Opera */
		-o-transform: rotate(90deg) translate(0px, 15px);
	}

	.closeButton {
		position:absolute; 
		max-height:27px;
		font-weight:900;
		cursor:pointer;					
	}

	.label:first-child {
		float: left;
	}
	.label:last-child {
		float: right;
	}
	#console {
		position: absolute;
		/* width: 25vw; */
		/* width: 300px; */
		max-width: 100vw;
		/* margin: 10px; */
		padding: 10px 20px;
		text-align: left;
		opacity: 0.95;
		/* font-size: 15.3px; */
		border-width: 2px;
		/* background-color: white; */
	}

	#access {
		position: absolute;
		top: 0;
		bottom: 0;
		width: 100%;
	}

	/* h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	} */

	/* @media (min-width: 640px) {
		main {
			max-width: none;
		}
	} */

	#citiesSelect {
      cursor:pointer;
      max-width: 215px;
      height:40px;
      /* color:#ccc; */
      font-weight:500;
      font-size: 16px;
      text-transform: uppercase;
	  /* border-width: 2px; */
      /* border-color: #ccc; */
      /* margin-top: 10px; */
	  margin:15px
	  /* transform:translate(18px,10px) */
    }
	
	.citiesSelect {
      cursor:pointer;
      max-width: 215px;
	  min-width: 215px;
      height:40px;
      /* color:#ccc; */
      font-weight:500;
      font-size: 14px;
      /* text-transform: uppercase; */
	  border-width: 2px;
      /* border-color: #ccc; */
      /* margin-top: 10px; */
	  margin:15px
	  /* transform:translate(18px,10px) */
    }

	/* #citiesSelect:hover {
		background-color: #fbb61a;
	} */

	.mapboxgl-popup-content {
	color: #ccc;
	}

	td {
	color: #ccc;
	border-bottom:1px solid black;
	border-bottom-width: 0px;
	z-index:0
	}

	.tableSep {
	border-left:1px solid #ccc;
	text-align: center;
	z-index:1
	}

	th {
	text-transform: uppercase;
	color: #ccc;
	border: none;
	}

	table, th, td {
	border-collapse: collapse;
	font-size:12px
	}

	.rounded-rect {
	background: black;
	opacity: 0.7;
	border-radius: 10px;
	box-shadow: 0 0 50px -25px black;
	}
	
	.flex-center {
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	}
	
	.flex-center.left {
	left: 0px;
	}
	
	.flex-center.right {
	right: 0px;
	}
	
	.sidebar-content {
	position: absolute;
	width: 95%;
	height: 95%;
	font-family: Arial, Helvetica, sans-serif;
	font-size: 32px;
	color: #ccc;
	}
	
	.sidebar-toggle {
	position: absolute;
	width: 1.3em;
	height: 1.3em;
	overflow: visible;
	display: flex;
	justify-content: center;
	align-items: center;
	}
	
	.sidebar-toggle.left {
	right: -1.5em;
	}
	
	.sidebar-toggle.right {
	left: -1.5em;
	}
	
	.sidebar-toggle:hover {
	color: orange;
	cursor: pointer;
	}
	
	.sidebar {
	transition: transform 1s;
	z-index: 1;
	width: 400px;
	height: 100%;
	}
	
	/*
	The sidebar styling has them "expanded" by default, we use CSS transforms to push them offscreen
	The toggleSidebar() function removes this class from the element in order to expand it.
	*/
	.left.collapsed {
	transform: translateX(-395px);
	}
	
	.right.collapsed {
	transform: translateX(395px);
	}
    </style>